// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.flatpickr-weekday {\n  display: inline-block;\n  width: 14.2857143%;\n}\nspan.flatpickr-day {\n  width: 14.2857143%;\n  margin: 0 2.491071428571428px;\n}\n@media screen and (min-width: 0\\0) {\n  div.flatpickr-current-month {\n    padding-top: 0px !important;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
